import { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { useBrandId } from '@ux/whitelabel';
import { getCookie } from '@uds/cookies';

// HostEurope brand ID - this is the only brand that gets Amazon Connect
const TARGET_BRAND_ID = 'b9c8f0f0-60dd-4cab-9da8-512b352d9c1a';

const AmazonConnectChat = () => {
  const brandId = useBrandId();
  const [hasInteracted, setHasInteracted] = useState(!!getCookie('pwinteraction'));
  useEffect(() => {
    if (hasInteracted) return;
    const interval = setInterval(() => {
      if (getCookie('pwinteraction')) {
        setHasInteracted(true);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [hasInteracted]);
  const INSTANCE_ID = window.HE_AMAZON_CONNECT_INSTANCE_ID;
  const SNIPPET_ID = window.HE_AMAZON_CONNECT_SNIPPET_ID;
  const CONNECT_URL = window.HE_AMAZON_CONNECT_URL;
  if (brandId !== TARGET_BRAND_ID) {
    return null;
  }
  if (!INSTANCE_ID || !SNIPPET_ID || !CONNECT_URL) {
    return null;
  }
  if (!hasInteracted) {
    return null;
  }
  return (
    <Helmet>
      <script type="text/javascript">
        {`
          (function(w, d, x, id){
            s=d.createElement('script');
            s.src='${CONNECT_URL}';
            s.async=1;
            s.id=id;
            d.getElementsByTagName('head')[0].appendChild(s);
            w[x] = w[x] || function() { (w[x].ac = w[x].ac || []).push(arguments) };
          })(window, document, 'amazon_connect', '${INSTANCE_ID}');
          
          amazon_connect('styles', {
            iconType: 'CHAT',
            openChat: { color: '#ffffff', backgroundColor: '#123456' },
            closeChat: { color: '#ffffff', backgroundColor: '#123456'}
          });
          
          amazon_connect('snippetId', '${SNIPPET_ID}');
          amazon_connect('supportedMessagingContentTypes', [
            'text/plain',
            'text/markdown',
            'application/vnd.amazonaws.connect.message.interactive',
            'application/vnd.amazonaws.connect.message.interactive.response'
          ]);
          amazon_connect('authenticate', function(callback) {
            const widgetId = '${INSTANCE_ID}';
            window.fetch('/api/amazon-token?widgetId=' + widgetId).then(res => {
              res.json().then(data => {
                callback(data.token);
              });
            });
          });
        `}
      </script>
    </Helmet>
  );
};

export default AmazonConnectChat;

